import request from "./request";

/**
 * 订单相关接口
 * @author 小圣贤君
 * @time 2020/03/13
 */
export default {
  /**
   * 下单，生成订单id
   * @param productId 产品id
   * @param num 购买数量
   */
  rushBuy(productId, num) {
    return request.post("/trade/tradeorder/rushbuy?productId=" + productId + "&num=" + num);
  },
  /**
   * 根据订单id，获取微信支付环境配置信息
   * @param orderId 订单id
   */
  getWxPay(orderId) {
    return request.post("/api/channel/wxpay?orderId=" + orderId);
  },
  /**
   * 获取支付订单记录
   * @param page 当前查询页
   * @param limit 每页限制条数
   * @param payStatus 支付状态 0 1
   * @param productType 这里默认3
   */
  queryOrderList(page, limit, payStatus) {
    return request.post("/trade/tradeorder/rush/orderlist?page=" + page + "&limit=" + limit + "&payStatus=" + payStatus + "&productType=3");
  },
  /**
   * 提货记录
   * @param page 当前查询页
   * @param limit 每页限制条数
   * @param flowStep 提货状态 0全部 1运输中 2已签收
   * @param productType 这里默认3
   */
  deliveryList(page, limit, flowStep) {
    return request.post("/trade/tradeextract/rush/extractlist?page=" + page + "&limit=" + limit + "&flowStep=" + flowStep + "&productType=3");
  },
  /**
   * 产品列表
   * @param productId
   */
  queryProducts(productId) {
    return request.get("/product//select?productId=" + productId);
  },
  /**
   * 计算运费
   * @param productNum 产品数量
   * @param userAddrId 地址id
   * @param productId 产品id
   */
  getFreight(productNum, userAddrId, productId) {
    return request.post("/trade/tradeorder/getFreight?productNum=" + productNum + "&userAddrId=" + userAddrId + "&productId=" + productId);
  },
  /**
   * 提货
   * @param productList
   * @param freightType
   * @param addrId
   */
  extract(data) {
    return request.post("/trade/tradeextract/extract", data);
  },
  /**
   * 提货微信支付
   * @param orderId
   */
  extractWxPay(orderId) {
    return request.post("/api/channel/extract/wxpay?orderId=" + orderId);
  },
  /**
   * 补货微信支付
   * @param orderId
   */
  orderWxPay(orderId) {
    return request.post("/api/channel/wxpay?orderId=" + orderId);
  },
  /**
   * 获取系统时间
   */
  getSysTime() {
    return request.post("/trade/tradeorder/rushinfo");
  },
  /**
   * 获取产品兑换比例
   * @param {*} sourceProductId 原产品
   * @param {*} sourceProductQuantity 原产品数量
   * @param {*} targetProductId 兑换目标产品
   */
  calcExchange(data) {
    return request.post("/trade/tradeextract/exchange/calculation", data);
  },
  /**
   * 获取剩余可抢提盒数
   */
  getLastCount(productId){
    return request.get("/trade/tradeextract/getAvailableQuantity?productId=" + productId);
  },
  /**
   * 查询物流记录
   */
   traceQuery(trackingNumber){
    return request.get("/trade/logistics/traceQuery?trackingNumber=" + trackingNumber);
  }
}



// WEBPACK FOOTER //
// ./src/api/orderService.js